/**
 * CSS class names used by the plugin
 */
export const CSS_CLASSES = {
    SUBMITTING: 'arts-ajax-form-comments_submitting',
    SUCCESS: 'arts-ajax-form-comments_success',
    ERROR: 'arts-ajax-form-comments_error',
    COMMENT_HIGHLIGHT: 'arts-ajax-form-comments__comment_highlight',
    COMMENT_REVEAL: 'arts-ajax-form-comments__comment_reveal',
    MESSAGE: 'arts-ajax-form-comments__message',
    MESSAGE_SUCCESS: 'arts-ajax-form-comments__message_success',
    MESSAGE_ERROR: 'arts-ajax-form-comments__message_error',
    ANIMATING_RESPONSE: 'arts-ajax-form-comments__response_animating'
};
